export enum OnCallRequestTypes {
  LIST = '@onCallRequest/LIST',
  LIST_SUCCESS = '@onCallRequest/LIST_SUCCESS',
  LIST_FAILED = '@onCallRequest/LIST_FAILED',
}
